/* eslint-disable react-hooks/exhaustive-deps */
import { FC, ReactNode, useEffect } from "react";
import clsx from "clsx";
import { Theme } from "@mui/material/styles";
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Routes from "src/Routes";
import { useObservable } from "src/framework/store/storeUtil";
import { isLoggedIn$ } from "src/framework/store/LoginStore";
import { openMenu$ } from "src/framework/store/AppStore";
import theme from "src/theme/light";

const drawerWidth = 0;
export const mobileWidth = (window.innerWidth*0.8);

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      height: "100%"
    },
    content: {
      flexGrow: 1,
      height: "100%",
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: drawerWidth,
    },
    contentShift: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
  })
);

interface IScafold {
  appBar?: ReactNode;
  drawer?: ReactNode;
  onExit: () => void;
  onInit: () => void;
}

const Scafold: FC<IScafold> =
  ({ appBar = "", drawer = "", onExit = () => { }, onInit = () => { } }) => {
    const classes = useStyles();

    const isLoggedIn = useObservable(isLoggedIn$)
    const openMenu = useObservable(openMenu$);

    useEffect(() => {
      onInit();
    }, [isLoggedIn]);

    useEffect(() => {
      return () => {
        onExit();
      };
    }, []);

    return (
      <div className={classes.root}>
        <CssBaseline />
        {appBar}
        {drawer}
        <main
          style={{ padding: "7px 17px" }}
          className={clsx(classes.content, {
            [classes.contentShift]: !openMenu,
          })}
        >
          <Toolbar />
          <Routes />
        </main>
      </div>
    );
  };
export { Scafold };
